import { formatDateForFilter } from "../utils/function";
import { authenticatedRequest, userInstance } from "./axios";

export const userLogin = (data, extraHeaders = {}) => {
  return userInstance("POST", "users/login", data, extraHeaders, true);
};
export const verifyOtp = (data) => {
  return userInstance("POST", "users/verify", data, { suppressToast: true }, true);
};
export const doctorSignUp = (data, extraHeaders = {}) => {
  return userInstance("POST", "doctor/signup", data, extraHeaders, true);
};
export const adminAllConsultation = () => {
  return userInstance("GET", "admin/getAllConsultation", {}, {}, false);
};
export const adminAllSubscriptions = () => {
  return userInstance("GET", "admin/subscriptions", {}, {}, false);
};
export const adminGetPartnesList = () => {
  return userInstance("GET", "admin/getPartners", {}, {}, false);
};
export const rejectPartnerOffer = (data) => {
  return userInstance("POST", "meeting/rejectPartnerOffer", data);
};
export const userPartnerConsent = (data) => {
  return userInstance("POST", "users/partnerConsent", data);
};
export const allConsultation = () => {
  return userInstance("GET", "consultation/getAllConsultation", {}, {}, true);
};
export const getUserProfile = (data) => {
  return userInstance("POST", "admin/getUserProfile", data);
};
export const userGetUserProfile = (data) => {
  return userInstance("POST", "users/getUserProfile", data);
};
export const updateUserProfile = (data) => {
  return userInstance("PATCH", "users/updateUserProfile", data);
};
export const MeetingPrice = () => {
  return userInstance("GET", "users/getDefaultPrice", {}, {}, true);
};
export const createMeeting = (data) => {
  return userInstance("POST", "meeting/createAppointment", data, {}, true);
};
export const adminCreateMeeting = (data) => {
  return userInstance("POST", "admin/createAppointment", data, {}, true);
};
export const meetingVerifyOtp = (data) => {
  return userInstance("POST", "meeting/verifyMeetingOtp", data, {}, true);
};
export const getCancel = (data) => {
  return userInstance("POST", "users/cancelMeeting", data);
};
export const Price = (data) => {
  return userInstance("POST", "users/getMeetingPrice", data);
};
export const documentView = (data) => {
  return userInstance("POST", "users/viewDocument", data);
};
export const medicalQuestionnaire = (data) => {
  return userInstance("POST", "users/addUpdateQuestionairre", data);
};
export const getAllAppointment = (data) => {
  return userInstance("POST", "meeting/getAllAppointment", data);
};
export const doctorComment = (data) => {
  return userInstance("POST", "meeting/doctorCommentOnMeeting", data);
};
export const doctorAllAppointment = (data) => {
  return userInstance("POST", "meeting/getAllAppointmentByDoctor", data);
};
export const doctorOfferDate = (data) => {
  return userInstance("POST", "doctor/offerDatesByMeetingid", data);
};
export const adminOfferDate = (data) => {
  return userInstance("POST", "admin/offerDatesByMeetingid", data);
};
export const doctorSummary = (data) => {
  return userInstance("POST", "doctor/addSummary", data);
};
export const doctorCreatePrescription = (data) => {
  return userInstance("POST", "doctor/prescriptions/create", data);
};
export const doctorSetPrescriptionSettings = (data) => {
  return userInstance("POST", "doctor/setPrescriptionSettings", data);
};
export const doctorGeneratePdf = (data) => {
  return userInstance("POST", "doctor/generatePdf", data);
};
export const refreshTokenGenerate = (data) => {
  return userInstance("GET", "users/refresh", data);
};
export const adminAllAppoinment = (data) => {
  return userInstance("GET", "admin/getAllAppointment", data);
};
export const adminAppoinment = (data) => {
  return userInstance("POST", "admin/getAppointment", data);
};
export const adminUpdatePrice = (data) => {
  return userInstance("POST", "admin/updatePrice", data);
};
export const adminCovertPartnersMeeting = (data) => {
  return userInstance("POST", "meeting/covertPartnersMeeting", data);
};
export const generatePartnersXmlMeetingReport = (data) => {
  return userInstance("POST", "reports/generatePartnersXmlMeetingReport", data);
};
export const uploadMeetingFile = (data) => {
  return userInstance("POST", "admin/uploadMeetingFile", data);
};
export const uploadMyDoctorFile = (data) => {
  return userInstance("POST", "admin/saveMyDoctors", data);
};
export const adminUpdateStatus = (data) => {
  return userInstance("POST", "admin/updateDoctorStatus", data);
};
export const adminGetUsers = (data) => {
  return userInstance("POST", "admin/getUsers", data);
};
export const adminCreateUser = (data) => {
  return userInstance("POST", "admin/createUser", data);
};

export const adminGetUtmDetailsList = (data) => {
  return userInstance("POST", "admin/getUtmDetailsList", data);
};

export const adminGetAnalyticsList = (data) => {
  return userInstance("POST", "admin/getAnalyticsDetailsList", data);
};

export const doctorCreateUser = (data) => {
  return userInstance("POST", "doctor/createPatient", data);
};

export const adminNoticiation = (data) => {
  return userInstance("POST", "admin/updateNotificationStatusOfDoctor", data);
};
export const doctorNoticiation = (data) => {
  return userInstance("POST", "doctor/updateNotificationStatusOfDoctor", data);
};
export const userCalendarNotification = (data) => {
  return userInstance(
    "POST",
    "users/activateCalendarNotificationByMeetingId",
    data
  );
};
export const collectiveData = () => {
  return userInstance("GET", "admin/getCollectives", {}, {}, false);
};

export const doctorSubscriptions = (data) => {
  return userInstance("GET", "doctor/subscriptions", data);
};

export const doctorSaveTemplate = (data) => {
  return userInstance("POST", "doctor/saveTemplate", data);
};

export const doctorUpdateTemplate = (data) => {
  return userInstance("POST", "doctor/updateTemplate", data);
};

export const createUserPassword = (data, headers, isPublic) => {
  return userInstance("POST", "users/createUserPassword", data, headers, isPublic);
};

export const forgotPassword = (data) => {
  return userInstance("POST", "users/forgotPassword", data, {}, true);
};

export const doctorGetTemplate = () => {
  return userInstance("GET", "doctor/getTemplates");
};

export const getUserDyteToken = (data) => {
  return userInstance("POST", "users/dyte-token", data);
};

export const getAllDocuments = (meetingId) => {
  const response = authenticatedRequest({
    method: "GET",
    url: `/meeting/meetingDocumentsByMeetingId/${meetingId}`,
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const getMriDocuments = (id) => {
  const response = authenticatedRequest({
    method: "GET",
    url: `/users/pacseeMeetingDocuments?meetingId=${id}`,
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const adminUpdateAppointmentById = (data) => {
  const response = authenticatedRequest({
    method: "post",
    url: "/admin/updateAppointmentById",
    data: data,
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const getDoctorsByConsultationId = (consultationId) => {
  const response = authenticatedRequest({
    method: "get",
    url: `/admin/getDoctorsByConsultationId/${consultationId}`,
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const adminAllDoctors = () => {
  return userInstance("GET", "admin/getAllDoctors", {}, {}, false);
};

export const secretaryAllAppointment = (data) => {
  return userInstance("POST", "secretary/appointments", data);
};

export const secretaryCreateUser = (data) => {
  return userInstance("POST", "secretary/createPatient", data);
};

export const adminAllSecretaries = () => {
  return userInstance("GET", "admin/getAllsecretaries", {}, {}, false);
};

export const getAdminAllDoctors = async () => {
  try {
    const response = await adminAllDoctors();
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getAdminAllSecretaries = async () => {
  try {
    const response = await adminAllSecretaries();
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const submitAnalytics = (data) => {
  return userInstance("POST", "analytics", data, {}, true);
};

// A wide range joins thousands of meetings across five collections, so the
// export is given far longer than the axios default.
const MEETING_REPORT_EXPORT_TIMEOUT_MS = 10 * 60 * 1000;

export const adminMeetingReportUtms = () => {
  return userInstance("GET", "admin/reports/meetings/utms", {}, {}, false);
};

export const adminMeetingReportCounts = (data) => {
  return userInstance("POST", "admin/reports/meetings/counts", data);
};

export const adminMeetingReportExport = (data) => {
  return authenticatedRequest({
    method: "post",
    url: "/admin/reports/meetings/export",
    data,
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "application/json",
    },
    timeout: MEETING_REPORT_EXPORT_TIMEOUT_MS,
  });
};

export const getAnalyticsChartData = async (data) => {
  return userInstance("POST", "admin/analytic/charts", data, {}, false);
};

export const getUTM = async (data) => {
  return userInstance("GET", "admin/analytic/utm", data, {}, false);
};

export const fetchAnalyticsChartData = async ({
  type,
  utm,
  fromDate,
  toDate,
}) => {
  try {
    const payload = {
      type,
      utm: utm?.value || utm || "",
      dateFrom: fromDate ? formatDateForFilter(fromDate, "start") : "",
      dateTo: toDate ? formatDateForFilter(toDate, "end") : "",
    };
    const response = await getAnalyticsChartData(payload);
    return response;
  } catch (error) {
    console.error("Analytics chart fetch error:", error);
    throw error;
  }
};
